module.exports = __webpack_public_path__ + "media/157.f33a08e8.mp3";